<div class="orders-container">
  <div class="orders-column">
    <h4 class="orders-title">Sell Orders (keys)</h4>
    <div class="orders-list">
      @for (o of data().sell_orders; track $index) {
        <div class="order-item">{{ o }}</div>
      }
      @if (data().sell_orders.length === 0) {
        <div class="order-item empty">No sell orders</div>
      }
    </div>
  </div>
  <div class="orders-column">
    <h4 class="orders-title">Buy Orders (keys)</h4>
    <div class="orders-list">
      @for (o of data().buy_orders; track $index) {
        <div class="order-item">{{ o }}</div>
      }
      @if (data().buy_orders.length === 0) {
        <div class="order-item empty">No buy orders</div>
      }
    </div>
  </div>
  <div class="orders-column">
    <h4 class="orders-title">Algo Orders (keys)</h4>
    <div class="orders-list">
      @for (o of data().algo_orders; track $index) {
        <div class="order-item">{{ o }}</div>
      }
      @if (data().algo_orders.length === 0) {
        <div class="order-item empty">No algo orders</div>
      }
    </div>
  </div>
</div>

<div class="pricing-calc">
  <div class="calc-row">
    <span class="calc-label">Price in Keys:</span>
    <input
      class="calc-input"
      type="number"
      [value]="priceInKeys()"
      (input)="onPriceInKeysChange($event)"
      step="0.01"
    />
  </div>
  <div class="calc-row">
    <span class="calc-label">Markup percent:</span>
    <input
      class="calc-input"
      type="number"
      [value]="markupPercent()"
      (input)="onMarkupChange($event)"
      step="1"
    />
    <span class="calc-suffix">%</span>
  </div>
  <div class="calc-row">
    <span class="calc-label">Key Price:</span>
    <span class="calc-prefix">$</span>
    <input
      class="calc-input"
      type="number"
      [value]="keyPrice()"
      (input)="onKeyPriceChange($event)"
      step="0.01"
    />
  </div>
  <div class="calc-row suggested">
    <span class="calc-label">Suggested Price:</span>
    <input
      class="calc-input suggested-price-input"
      type="text"
      [value]="suggestedPrice() | currency : 'USD' : 'symbol' : '1.2-2'"
      readonly
    />
    <button
      type="button"
      class="button button--style-primary h-24 padding-x-8 rounded-4"
      (click)="applySuggested()"
    >
      Apply
    </button>
  </div>
</div>
